export const shallowIncludes = (arr = [], id) => {
  return arr.some((x) => x == id);
};